module.exports = __webpack_public_path__ + "img/unstabilized_asphalted.c640a6ff.png";